export default __webpack_public_path__ + "static/media/banner.1ffa4e97.webp";